import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchCampaigns } from 'api/campaigns';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { accountQueryKeys } from 'queries/account-query-keys';

const useSavedCampaigns = (campaigns: string[]) => {
    const { accountId } = useCurrentAccount();

    const params = {
        ids: campaigns.filter(c => c !== 'any').map(c => Number(c)),
        per_page: campaigns.length || 1,
    };

    return useSuspenseQuery({
        queryKey: accountQueryKeys.campaignsWithFilters(accountId, params),
        queryFn: () => fetchCampaigns(accountId, params),
        select: data => {
            return data.data.map(c => ({
                id: c.id.toString(),
                label: c.title,
            }));
        },
    });
};

export { useSavedCampaigns };
